import React, { useCallback, useEffect, useRef, memo } from 'react';
import echarts from '@gp/utils/echarts.config';
// @ts-ignore
import { isEqual } from 'lodash-es';

const Echart = ({
  renderType = 'canvas', //默认渲染模式canva 类型
  options: chartOptions = {}, // options
  style = { width: '100%', height: '100%' }, // 样式
  onHoverChange, //点击事件
  onClickChange, //鼠标hover事件
  legendselectchanged, //legend点击事件
  refresh, // 这个值一定是变化的, 变化了echart就会刷新渲染
  mouseMsg, // ref，告知鼠标的相关信息
}) => {
  const chartRef = useRef(); //当前div实例
  const chartInstance = useRef(null); // 用于保存上一次chartRef被赋值的实例对象
  // 是否需要 dispose echart实例，图例change事件时，不要dispose，因为图例change事件，如果dispose了echart，echart内部图例change的交互 会有报错，因为echart实例被dispose了
  const isNeedDispose = useRef(true);
    //监听屏幕变化，重绘图表
  //  const listenerResize  = (chart) =>{
  //     if (chart) {
  //       chart.resize();
  //     }
  //  }
  const listenerResize  = useCallback(() =>{
    if (chartInstance?.current) {
      setTimeout(() => {
        chartInstance?.current.resize();
      }, 0);
    }
  }, []);
   const setPieLabelLayout = (params ,  myChart)=> {  //配置环形图图的折线长度
    const isLeft = params.labelRect.x < myChart.getWidth() / 2;
        const points = params.labelLinePoints;
        if(!points) return {}
        // Update the end point.
        points[2][0] = isLeft
          ? params.labelRect.x
          : params.labelRect.x + params.labelRect.width;
      return {labelLinePoints: points};
   }

  //初始化图表，设置配置项
    const renderChart = useCallback(() => {
      const render = echarts?.getInstanceByDom(chartRef.current);
      let chartInstanceCurrent = chartInstance?.current;
      if (render) {
        chartInstanceCurrent = render;
      } else {
        chartInstanceCurrent = echarts?.init(chartRef.current, null, {
          renderer: renderType,
        });
      }
      chartInstance.current = chartInstanceCurrent;
      //绑定点击事件
      onClickChange &&
        chartInstanceCurrent.on('click', (params) => {
          onClickChange(params);
        });
      //鼠标hover事件
      onHoverChange &&
        chartInstanceCurrent.on('mousemove', (params) => {
          onHoverChange(params);
        });
      //鼠标legend点击事件
      legendselectchanged &&
        chartInstanceCurrent.on('legendselectchanged', (params) => {
          isNeedDispose.current = false;
          legendselectchanged(params);
        });
      //设置环形图的labelLayout
      if((chartOptions.series && (chartOptions.series[0]?.type ?? '')) === 'pie'){  //当echart为环形图时
          const pieSeriesItem = chartOptions?.series[0]
          pieSeriesItem.labelLayout = ( params) => setPieLabelLayout(params, chartInstanceCurrent )
      }
      //设置配置项
      chartInstanceCurrent.setOption(chartOptions);

      //监听屏幕变化事件 传入当前chart实例
      window.addEventListener('resize', listenerResize);
      return () => {
        window.removeEventListener('resize', listenerResize);
      };

    }, [chartOptions, renderType, listenerResize]);

    useEffect(() => {
      renderChart();
      return () => {
        const { current } = chartInstance;
        if (current) {
          //销毁 chartInstance, 实则销毁上一个chartRef 销毁实例释放资源 避免内存泄漏
          // current.dispose();

          if (isNeedDispose.current) {
            current.dispose();
          } else {
            // 放下一个事件循环 重置 是否需要dispose的标识，防止外界组件 多次修改chartOptions时，提前重置 是否需要dispose的标识 导致 echarts图 dispose
            setTimeout(() => {
              isNeedDispose.current = true;
            }, 0);
          }
        }
      };
    }, [chartOptions]);

  // 手动执行刷新
  useEffect(() => {
    if (!refresh) return;
    if (chartRef.current) {
      const myChart = echarts.getInstanceByDom(chartRef.current);
      myChart.resize();
    }
  }, [refresh]);

  const handleMouseMove = useCallback((e) => {
    if (mouseMsg) {
      mouseMsg.current = e;
    }
  }, []);

  return (
    <div
      ref={chartRef}
      style={style}
      // 鼠标在echarts上移动时，获取鼠标的相关信息
      onMouseMove={handleMouseMove}
    />
  );
};
function areEqual(prevProps, nextProps) {
  return isEqual(prevProps, nextProps);
}
export default memo(Echart, areEqual);
